import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function minMaxValidator(minKey: string, maxKey: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const minControl = group.get(minKey);
    const maxControl = group.get(maxKey);

    if (!minControl || !maxControl) return null;

    const min = minControl.value;
    const max = maxControl.value;

    const minErrors = { ...minControl.errors };
    delete minErrors['minTooBig'];

    const maxErrors = { ...maxControl.errors };
    delete maxErrors['maxTooSmall'];

    let hasError = false;

    if (min != null && max != null && min > max) {
      minControl.setErrors({ ...minErrors, minTooBig: true });
      maxControl.setErrors({ ...maxErrors, maxTooSmall: true });
      hasError = true;
    } else {
      minControl.setErrors(Object.keys(minErrors).length ? minErrors : null);
      maxControl.setErrors(Object.keys(maxErrors).length ? maxErrors : null);
    }

    return null;
  };
}
